<template>
  <div class="transfer-task-root">
    <!-- 顶部标题栏 -->
    <div class="header-bar">
      <span class="header-title">分部转运总单</span>
      <!-- 操作按钮已注释 -->
    </div>
    <div class="main-row">
      <!-- 左侧菜单 可拖拽宽度 -->
      <div
          class="side-menu"
          :style="{width: leftWidth + 'px'}"
      >
        <div class="search-bar-row">
          <a-input-search
              placeholder="转运单号"
              style="width: 60%;"
              v-model="searchTaskId"
              allowClear
              @search="onSearch"
          />
          <div class="search-bar-actions">
            <a-tooltip placement="top" title="刷新">
              <a-icon type="reload" class="search-bar-icon" @click="refreshMenuList"/>
            </a-tooltip>
            <a-tooltip placement="top" title="新增">
              <a-icon type="plus" class="search-bar-icon" @click="onAddTask"/>
            </a-tooltip>
            <a-tooltip placement="top" title="修改">
              <a-icon type="edit" class="search-bar-icon"
                      @click="onEditTask(menuList.find(item => item.id === selectedId))"/>
            </a-tooltip>
            <a-tooltip placement="top" title="删除">
              <a-icon type="delete" class="search-bar-icon"
                      @click="onDeleteTask(menuList.find(item => item.id === selectedId))"/>
            </a-tooltip>
          </div>
        </div>
        <!-- 状态筛选器 -->
        <div class="status-filter-row">
          <a-radio-group style="display: flex;gap: 2px" v-model="statusFilter" size="small" @change="onStatusFilterChange">
            <a-radio-button value="all">全部</a-radio-button>
            <a-radio-button value="0">未开始</a-radio-button>
            <a-radio-button value="1">装车中</a-radio-button>
            <a-radio-button value="3">转运中</a-radio-button>
            <a-radio-button value="4">已到达</a-radio-button>
            <a-radio-button value="5">已完成</a-radio-button>
          </a-radio-group>
        </div>
        <div class="menu-list">
          <div
              v-for="item in menuList"
              :key="item.id"
              :class="['menu-item', `status-${item.status}`, { active: item.id === selectedId, disabled: item.enable === 0 }]"
              @click="selectedId = item.id"
          >
            <!-- 状态指示器 -->
            <div class="status-indicator" :class="`indicator-${item.status}`"></div>

            <div class="menu-item-row" :title="item.code">
              <div class="menu-item-header">
                <!-- 状态图标 -->
                <span class="status-icon" :class="`icon-${item.status}`">
                  <a-icon :type="getStatusIcon(item.status)" />
                </span>
                <span class="menu-code">{{ item.taskId }}</span>
                <a-button
                    type="link"
                    size="small"
                    @click.stop="copyToClipboard(item.taskId)"
                    style="margin-left: 6px; padding: 0 4px; color: rgb(82, 196, 26)"
                    title="复制"
                >
                  <a-icon type="copy" style="font-size: 12px;"/>
                </a-button>
              </div>
              <span class="menu-arrow"><a-icon type="right"/></span>
            </div>
            <div class="menu-item-info">
              <span
                  class="menu-location"
                  :title="item.originName + ' - ' + item.destinationName"
                  :style="{maxWidth: (leftWidth - 80) + 'px'}"
              >
                {{ item.originName }} - {{ item.destinationName }}
              </span>
              <!-- 状态标签 -->
              <span class="menu-status-badge" :class="`badge-${item.status}`">
                {{ getStatusText(item.status) }}
              </span>
            </div>
          </div>
        </div>
        <div class="menu-pagination">
          <a-pagination
              :current="menuPage"
              :pageSize="menuPageSize"
              :total="menuTotal"
              showSizeChanger
              :show-total="total => `总共 ${menuTotal} 个`"
              @change="onMenuPageChange"
              @showSizeChange="onMenuPageChange"
              size="small"
          />
        </div>
      </div>
      <!-- 拖拽分割条 -->
      <div class="drag-bar" @mousedown="onDragStart"></div>
      <!-- 右侧内容 -->
      <div class="main-content">
        <div class="main-card">
          <!-- 顶部信息 -->
          <div class="main-info">
            <div class="main-info-title">
              {{ selectedItem ? selectedItem.taskId : '--' }}
              <a-tooltip placement="top" title="刷新">
                <a-icon type="reload" class="refresh-icon" @click="refreshRightData" />
              </a-tooltip>
            </div>
            <div class="main-info-desc">
              {{ selectedItem ? (selectedItem.originName + ' - ' + selectedItem.destinationName) : '--' }}
            </div>
          </div>
          <!-- 步骤条 -->
          <div class="main-steps">
            <a-steps :current="getStepCurrent(selectedItem)" style="margin-bottom: 0;">
              <a-step
                  v-for="(step, idx) in steps"
                  :key="step.status"
                  :title="step.label"
                  :description="selectedItem ? (selectedItem[step.timeField] || '') : ''"
                  :status="getStepStatus(idx, selectedItem)"
              />
            </a-steps>
          </div>
          <!-- 包裹统计和导出按钮 -->
          <div class="main-summary">
            <span>{{ detail.totalBag }}袋 / {{ detail.totalCount }}件，{{ detail.totalWeight }}KG</span>
            <span v-if="selectedItem && selectedItem.status !== 0" style="margin-left: 20px;">
              车牌号：<span style="color: #1890ff;font-weight: 500">{{ selectedItem.plateNumber || '--' }}</span>
              | 车辆编码：<span style="color: #1890ff;font-weight: 500">{{ selectedItem.vehicleNumber || '--' }}</span>
            </span>
          </div>
          <!-- 表格滚动区 -->
          <div class="table-list">
            <a-table
                :columns="columns"
                :dataSource="tableData"
                :pagination="false"
                rowKey="id"
                size="middle"
                bordered
                class="main-table"
                :scroll="{ x: 'max-content' }"
            >
              <template slot="status" slot-scope="text">
                <span style="color: #52c41a;">{{ getStatusText(text) }}</span>
              </template>
            </a-table>
          </div>
          <!-- 右侧分页控件 -->
          <div class="table-pagination">
            <a-pagination
                :current="tablePage"
                :pageSize="tablePageSize"
                :total="tableTotal"
                showSizeChanger
                :show-total="total => `总共 ${tableTotal} 个`"
                @change="onTablePageChange"
                @showSizeChange="onTablePageChange"
                size="small"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗表单组件集成 -->
    <transfer-task-form-modal
        :visible="formModalVisible"
        :isEdit="isEdit"
        :editData="editData"
        @submit="handleFormSubmit"
        @cancel="handleFormCancel"
    />
  </div>
</template>

<script>
import TransferTaskFormModal from './modules/TransferTaskFormModal.vue';
import {
  insertTrajectoryTask,
  updateTrajectoryTask,
  deleteTrajectoryTask,
  pageTrajectoryTask,
  pageTrajectoryTaskDetails,
  getTransportTaskStatistics
} from 'api/transport'
// mock右侧表格接口（请替换为真实接口）
export default {
  components: {
    TransferTaskFormModal
  },
  data() {
    return {
      searchTaskId: '', // 搜索关键字
      selectedId: null,
      statusFilter: 'all', // 状态筛选
      // 左侧菜单分页
      menuList: [],
      menuPage: 1,
      menuPageSize: 10,
      menuTotal: 0,
      // 右侧表格分页
      tableData: [],
      tablePage: 1,
      tablePageSize: 10,
      tableTotal: 0,
      detail: {},
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {title: '袋号', dataIndex: 'boxNum', key: 'boxNum', align: "center",},
        {title: '件数（件）', dataIndex: 'totalCount', key: 'totalCount', width: 100, align: "center",},
        {title: '重量（KG）', dataIndex: 'totalWeight', key: 'totalWeight', width: 100, align: "center",},
        {title: '装车人', dataIndex: 'loadingUser', key: 'loadingUser', width: 120, align: "center",},
        {title: '装车时间', dataIndex: 'loadingTime', key: 'loadingTime', width: 150, align: "center",},
        {title: '卸车人', dataIndex: 'unLoaderUser', key: 'unLoaderUser', width: 120, align: "center",},
        {title: '卸车时间', dataIndex: 'unLoaderTime', key: 'unLoaderTime', width: 150, align: "center",},
      ],
      leftWidth: 350,
      dragging: false,
      startX: 0,
      startWidth: 260,
      // 新增弹窗相关
      formModalVisible: false,
      isEdit: false,
      editData: {},
      steps: [
        {status: 0, label: '未开始', timeField: 'createTime'},
        {status: 1, label: '装车中', timeField: 'loadingTime'},
        {status: 3, label: '转运中', timeField: 'transitTime'},
        {status: 4, label: '已到达', timeField: 'arrivalTime'},
        {status: 5, label: '已完成', timeField: 'completeTime'}
      ],
    }
  },
  computed: {
    selectedItem() {
      return this.menuList.find(item => item.id === this.selectedId);
    }
  },
  watch: {
    selectedId: {
      handler() {
        this.tablePage = 1;
        this.refreshTableData();
        this.refreshStatistics(); // 添加统计数据刷新
      }
    }
  },
  methods: {
    copyToClipboard(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      document.body.appendChild(textarea)
      textarea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('已复制到剪贴板')
        } else {
          this.$message.error('复制失败')
        }
      } catch (err) {
        this.$message.error('复制失败: ' + err)
      } finally {
        document.body.removeChild(textarea)
      }
    },
    // 刷新统计数据
    async refreshStatistics() {
      if (!this.selectedItem || !this.selectedItem.taskId) {
        this.detail = {};
        return;
      }
      try {
        const res = await getTransportTaskStatistics({
          taskId: this.selectedItem.taskId
        });
        this.detail = res.data || {};
      } catch (e) {
        this.$message.error('统计数据获取失败');
      }
    },
    // 刷新右侧数据
    async refreshRightData() {
      if (!this.selectedItem) {
        this.$message.warning('请先选择一个任务');
        return;
      }
      this.$message.loading('正在刷新数据...', 0.5);
      await Promise.all([
        this.refreshTableData(),
        this.refreshStatistics()
      ]);
      // this.$message.success('数据刷新成功');
    },
    onAddTask() {
      this.isEdit = false;
      this.editData = {};
      this.formModalVisible = true;
    },
    onEditTask(item) {
      if (!item) {
        this.$message.warning('请先选择要编辑的任务');
        return;
      }
      // 检查任务状态
      if ([2, 3, 4, 5].includes(item.status)) {
        this.$message.warning('任务已经在转运中，不允许修改');
        return;
      }
      this.isEdit = true;
      this.editData = {...item};
      this.formModalVisible = true;
    },
    // 删除任务
    onDeleteTask(item) {
      if (!item) {
        this.$message.warning('请先选择要删除的任务');
        return;
      }
      // 检查任务状态
      if (item.status !== 0) {
        this.$message.warning('仅未开始任务允许删除');
        return;
      }
      this.$confirm({
        title: '确认删除',
        content: `您确定要删除 ${item.taskId} 的转运任务吗？`,
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          try {
            const params = {
              taskId: item.taskId
            };
            const resp = await deleteTrajectoryTask(params);
            if (resp && resp.code == '200') {
              this.$message.success('删除转运任务成功');
              this.refreshMenuList();
            } else {
              this.$message.error(resp?.msg || '删除转运任务失败')
            }
          } catch (e) {
            this.$message.error('删除失败');
          }
        }
      });
    },
    getStatusText(status) {
      const map = {
        0: '未开始',
        1: '装车中',
        2: '已装车',
        3: '转运中',
        4: '已到达',
        5: '已完成'
      }
      return map[status] !== undefined ? map[status] : status
    },
    getStatusColor(status) {
      const colorMap = {
        0: '#9E9E9E',  // 未开始 - 灰色，表示待处理
        1: '#2196F3',  // 装车中 - 蓝色，表示进行中
        2: '#4CAF50',  // 已装车 - 绿色，表示完成一步
        3: '#FF9800',  // 转运中 - 橙色，表示运输中
        4: '#673AB7',  // 已到达 - 紫色，表示到达目的地
        5: '#03692a'   // 已完成 - 深灰色，表示全部完成
      }
      return colorMap[status] || '#000000' // 默认黑色
    },
    // 获取状态对应的图标
    getStatusIcon(status) {
      const iconMap = {
        0: 'clock-circle',     // 未开始 - 时钟图标
        1: 'inbox',            // 装车中 - 装箱图标（不旋转）
        2: 'check-circle',     // 已装车 - 勾选图标
        3: 'car',              // 转运中 - 汽车图标
        4: 'environment',      // 已到达 - 位置图标
        5: 'check-circle'      // 已完成 - 勾选图标
      }
      return iconMap[status] || 'question-circle'
    },
    // 状态筛选变化事件
    onStatusFilterChange() {
      this.menuPage = 1; // 重置到第一页
      this.refreshMenuList();
    },
    // 步骤条当前节点
    getStepCurrent(item) {
      if (!item) return 0;
      // 找到当前status在steps中的索引
      const idx = this.steps.findIndex(s => s.status === item.status);
      return idx === -1 ? 0 : idx;
    },
    // 步骤条每个节点状态
    getStepStatus(idx, item) {
      if (!item) return 'wait';
      const currentIdx = this.getStepCurrent(item);
      if (idx < currentIdx) return 'finish';
      if (idx === currentIdx) return 'process';
      return 'wait';
    },
    async handleFormSubmit(formData) {
      console.log('提交表单数据:', formData)
      if (this.isEdit) {
        // 编辑逻辑
        try {
          const resp = await updateTrajectoryTask(formData);
          if (resp && resp.code == '200') {
            this.$message.success('修改成功');
            this.refreshMenuList();
          } else {
            this.$message.error(resp?.msg || '修改失败')
          }
          this.formModalVisible = false;
        } catch (e) {
          this.$message.error('修改失败');
        }
      } else {
        // 新增逻辑
        try {
          const resp = await insertTrajectoryTask(formData);
          this.formModalVisible = false;
          if (resp && resp.code == '200') {
            this.$message.success('创建转运任务成功');
            this.refreshMenuList();
          } else {
            this.$message.error(resp?.msg || '创建转运任务失败')
          }
        } catch (e) {
          this.$message.error('新增失败');
        }
      }
    },
    handleFormCancel() {
      this.formModalVisible = false;
    },
    // 左侧菜单分页事件
    onMenuPageChange(page, pageSize) {
      this.menuPage = page;
      this.menuPageSize = pageSize;
      this.refreshMenuList();
    },
    // 搜索事件
    onSearch() {
      this.menuPage = 1; // 重置到第一页
      this.refreshMenuList();
    },
    // 刷新左侧菜单
    async refreshMenuList() {
      try {
        const params = {
          current: this.menuPage,
          size: this.menuPageSize,
          taskId: this.searchTaskId // 添加搜索条件
        };
        
        // 根据状态筛选添加status参数
        if (this.statusFilter !== 'all') {
          params.status = this.statusFilter;
        }
        
        const res = await pageTrajectoryTask(params);
        this.menuList = res.data.records || [];
        this.menuTotal = res.data.total || 0;
        // 自动选中第一条
        if (this.menuList.length > 0) {
          this.selectedId = this.menuList[0].id;
        } else {
          this.selectedId = null;
        }
      } catch (e) {
        this.$message.error('菜单列表刷新失败');
      }
    },
    // 右侧表格分页事件
    onTablePageChange(page, pageSize) {
      this.tablePage = page;
      this.tablePageSize = pageSize;
      this.refreshTableData();
    },
    // 刷新右侧表格
    async refreshTableData() {
      if (!this.selectedItem || !this.selectedItem.taskId) {
        this.tableData = [];
        this.tableTotal = 0;
        return;
      }
      try {
        const res = await pageTrajectoryTaskDetails({
          current: this.tablePage,
          size: this.tablePageSize,
          taskId: this.selectedItem.taskId
        });
        this.tableData = res.data.records || [];
        this.tableTotal = res.data.total || 0;
      } catch (e) {
        this.$message.error('表格数据刷新失败');
      }
    },
    onDragStart(e) {
      this.dragging = true;
      this.startX = e.clientX;
      this.startWidth = this.leftWidth;
      document.body.style.userSelect = 'none'; // 禁止选中
      document.addEventListener('mousemove', this.onDragging);
      document.addEventListener('mouseup', this.onDragEnd);
      e.preventDefault();
      e.stopPropagation();
    },
    onDragging(e) {
      if (!this.dragging) return;
      const delta = e.clientX - this.startX;
      let newWidth = this.startWidth + delta;
      if (newWidth < 340) newWidth = 340;
      if (newWidth > 500) newWidth = 500;
      this.leftWidth = newWidth;
      e.preventDefault();
      e.stopPropagation();
    },
    onDragEnd(e) {
      this.dragging = false;
      document.body.style.userSelect = '';
      document.removeEventListener('mousemove', this.onDragging);
      document.removeEventListener('mouseup', this.onDragEnd);
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 0);
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  },
  mounted() {
    // 解决刷新后拖拽事件未解绑问题
    window.addEventListener('mouseup', this.onDragEnd);
    // 初始化加载分页数据
    this.refreshMenuList();
    this.refreshTableData();
    this.refreshStatistics(); // 添加统计数据初始化
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.onDragEnd);
  }
}
</script>

<style scoped>
.transfer-task-root {
  background: #f5f7fa;
  height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
}

.header-bar {
  height: 48px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
}

.main-row {
  display: flex;
  height: calc(100vh - 48px);
}

.side-menu {
  background: #fff;
  border-right: 1px solid #e8e8e8;
  padding: 0;
  height: 100%;
  min-width: 340px;
  max-width: 500px;
  box-sizing: border-box;
  transition: width 0.1s;
  position: relative;
  display: flex;
  flex-direction: column;
}

.drag-bar {
  width: 5px;
  cursor: ew-resize;
  background: #f0f0f0;
  height: 100%;
  z-index: 10;
  transition: background 0.2s;
}

.drag-bar:hover {
  background: #d0d0d0;
}

.menu-list {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;
}

.menu-list::-webkit-scrollbar {
  width: 6px;
}

.menu-list::-webkit-scrollbar-track {
  background: transparent;
}

.menu-list::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}

.menu-list::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}

.menu-pagination {
  flex-shrink: 0;
  padding: 8px 8px 20px 0;
  background: #fff;
  text-align: right;
  z-index: 2;
}

.menu-item {
  padding: 8px 16px;
  cursor: pointer;
  border-left: 3px solid transparent;
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.2s, border-color 0.2s;
  position: relative;
  overflow: hidden;
}

/* 状态指示器 */
.status-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0; /* 默认隐藏 */
  transition: all 0.3s;
  opacity: 0;
}

.indicator-0 { background: #595959; } /* 未开始 - 与标签颜色相同 */
.indicator-1 { background: #0958d9; } /* 装车中 - 与标签颜色相同 */
.indicator-2 { background: #389e0d; } /* 已装车 - 与标签颜色相同 */
.indicator-3 { background: #d46b08; } /* 转运中 - 与标签颜色相同 */
.indicator-4 { background: #531dab; } /* 已到达 - 与标签颜色相同 */
.indicator-5 { background: #237804; } /* 已完成 - 与标签颜色相同 */

/* 不同状态的背景色 */
.menu-item.status-0 { background: linear-gradient(90deg, #fafafa 0%, #ffffff 100%); }
.menu-item.status-1 { background: linear-gradient(90deg, #e6f7ff 0%, #ffffff 100%); }
.menu-item.status-2 { background: linear-gradient(90deg, #f6ffed 0%, #ffffff 100%); }
.menu-item.status-3 { background: linear-gradient(90deg, #fff7e6 0%, #ffffff 100%); }
.menu-item.status-4 { background: linear-gradient(90deg, #f9f0ff 0%, #ffffff 100%); }
.menu-item.status-5 { background: linear-gradient(90deg, #f6ffed 0%, #ffffff 100%); }

.menu-item.active {
  background: #e6f7ff !important;
  border-left: 3px solid #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

/* 不同状态选中时的边框颜色 */
.menu-item.active.status-0 { border-left-color: #595959; }
.menu-item.active.status-1 { border-left-color: #0958d9; }
.menu-item.active.status-2 { border-left-color: #389e0d; }
.menu-item.active.status-3 { border-left-color: #d46b08; }
.menu-item.active.status-4 { border-left-color: #531dab; }
.menu-item.active.status-5 { border-left-color: #237804; }

/* 只有选中状态才显示状态指示器 */
.menu-item.active .status-indicator {
  width: 4px;
  opacity: 1;
}

.menu-item:hover {
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* 只有选中项悬停时状态指示器才变宽 */
.menu-item.active:hover .status-indicator {
  width: 6px;
}

.menu-item:hover .status-icon {
  transform: scale(1.1);
}

.menu-item:hover .menu-status-badge {
  transform: scale(1.05);
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.menu-item-row {
  display: flex;
  align-items: center;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  justify-content: space-between;
  margin-left: 8px; /* 为状态指示器留出空间 */
}

.menu-item-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 状态图标样式 */
.status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 12px;
  transition: all 0.3s;
}

.icon-0 { background: #f5f5f5; color: #8c8c8c; } /* 未开始 */
.icon-1 { background: #e6f7ff; color: #1890ff; } /* 装车中 */
.icon-2 { background: #f6ffed; color: #52c41a; } /* 已装车 */
.icon-3 { background: #fff7e6; color: #fa8c16; } /* 转运中 */
.icon-4 { background: #f9f0ff; color: #722ed1; } /* 已到达 */
.icon-5 { background: #f6ffed; color: #389e0d; } /* 已完成 */

.menu-code {
  max-width: 200px;
  color: #1890ff;
  font-size: 15px;
  font-weight: 500;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.menu-arrow {
  margin-left: 8px;
  flex-shrink: 0;
  color: #bfbfbf;
}

.menu-item.active .menu-arrow {
  color: #1890ff;
}

.menu-item-info {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #888;
  margin-top: 8px;
  white-space: nowrap;
  overflow: hidden;
  justify-content: space-between;
  margin-left: 8px; /* 为状态指示器留出空间 */
}

/* 状态标签样式 */
.menu-status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  min-width: 50px;
  transition: all 0.3s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.badge-0 { background: #f5f5f5; color: #595959; border: 1px solid #d9d9d9; } /* 未开始 */
.badge-1 { background: #e6f7ff; color: #0958d9; border: 1px solid #91d5ff; } /* 装车中 */
.badge-2 { background: #f6ffed; color: #389e0d; border: 1px solid #b7eb8f; } /* 已装车 */
.badge-3 { background: #fff7e6; color: #d46b08; border: 1px solid #ffd591; } /* 转运中 */
.badge-4 { background: #f9f0ff; color: #531dab; border: 1px solid #d3adf7; } /* 已到达 */
.badge-5 { background: #f6ffed; color: #237804; border: 1px solid #95de64; } /* 已完成 */

.menu-location {
  /* max-width 由绑定动态控制 */
  font-weight: 500;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}



.main-content {
  background: #f5f7fa;
  min-height: 0;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.main-card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px #f0f1f2;
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  padding: 24px;
}

.main-info {
  margin-bottom: 15px;
}

.main-info-title {
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon {
  font-size: 16px;
  color: #666;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s;
}

.refresh-icon:hover {
  color: #1890ff;
  transform: rotate(180deg);
}

.main-info-desc {
  color: #888;
  margin-top: 2px;
}

.main-steps {
  margin-bottom: 18px;
}

.step-num {
  display: inline-block;
  background: #1890ff;
  color: #fff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 22px;
  font-size: 14px;
  margin-left: 8px;
}

.main-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 15px;
  flex-shrink: 0;
}

.main-table {
  background: #fff;
  flex: 1;
  min-width: 0;
}

.search-bar-row {
  display: flex;
  align-items: center;
  padding: 8px 0 8px 0;
  border-bottom: 1px solid #e8e8e8;
  margin: 0 12px 8px 12px;
  justify-content: space-between;
}

.search-bar-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-bar-icon {
  font-size: 18px;
  color: #333;
  cursor: pointer;
  transition: color 0.2s;
}

.search-bar-icon:hover {
  color: #1890ff;
}

/* 状态筛选器样式 */
.status-filter-row {
  padding: 8px 12px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}

.status-filter-row .ant-radio-group {
  width: 100%;
}

.status-filter-row .ant-radio-button-wrapper {
  font-size: 12px;
  height: 28px;
  line-height: 26px;
  padding: 0 8px;
  flex: 1;
  text-align: center;
  border-radius: 4px;
}

.status-filter-row .ant-radio-button-wrapper-checked {
  background: #1890ff;
  border-color: #1890ff;
  color: #fff;
  font-weight: 600;
}

/* 响应式调整 */
@media (max-width: 400px) {
  .status-filter-row .ant-radio-button-wrapper {
    font-size: 10px;
    padding: 0 4px;
  }

  .menu-status-badge {
    font-size: 10px;
    padding: 1px 6px;
    min-width: 40px;
  }

  .status-icon {
    width: 16px;
    height: 16px;
    font-size: 10px;
  }
}

.table-list {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  /* 自定义滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
}

.table-list::-webkit-scrollbar {
  width: 6px;
}

.table-list::-webkit-scrollbar-track {
  background: transparent;
}

.table-list::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.table-list::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.table-pagination {
  flex-shrink: 0;
  padding: 8px 0 0 0;
  background: #fff;
  text-align: right;
  z-index: 2;
}

:deep(.ant-steps-item-finish .ant-steps-item-icon) {
  background: #1890ff !important;
}

:deep(.ant-steps-item-finish .ant-steps-icon) {
  color: #fff !important;
}

.menu-item.disabled {
  position: relative;
  opacity: 0.7;
}

.menu-item.disabled::after {
  content: "已禁用";
  position: absolute;
  top: 50%;
  left: 70%;
  transform: translate(-50%, -50%) rotate(-20deg);
  font-size: 18px;
  color: #ff4d4f;
  font-weight: 600;
  pointer-events: none;
  z-index: 1;
  opacity: 0.8;
}
</style>
